import { OnlineEvaluationHeaderComponent } from './online-evaluation-layout/online-evaluation-header/online-evaluation-header.component';
import { OnlineEvaluationLayoutComponent } from './online-evaluation-layout/online-evaluation-layout.component';
import { ShopkeeperHeaderComponent } from './shopkeeper-layout/shopkeeper-header/shopkeeper-header.component';
import { ShopkeeperLayoutComponent } from './shopkeeper-layout/shopkeeper-layout.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { SharedPipesModule } from '../../pipes/shared-pipes.module';
import { SidebarComponent } from './admin-layout/sidebar/sidebar.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FooterComponent } from '../footer/footer.component';
import { SharedDirectivesModule } from '../../directives/shared-directives.module';
import { FormsModule } from '@angular/forms';
import { HeaderSidebarComponent } from './admin-layout/header/header-sidebar.component';
import { BlankLayoutComponent } from './blank-layout/blank-layout.component';
import { AuthLayoutHeaderComponent } from './auth-layout-header/auth-layout-header.component';
import { HeaderAccountDropdownComponent } from './shopkeeper-layout/shopkeeper-header/header-account-dropdown/header-account-dropdown.component';
import { PluginRaioXLayoutComponent } from './plugin-raio-x-layout/plugin-raio-x-layout.component';
import { PluginRaioXTermsComponent } from './plugin-raio-x-layout/plugin-raio-x-terms.component';
import { OnlineEvaluationTermsComponent } from './online-evaluation-layout/online-evaluation-terms/online-evaluation-terms.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { BannerMobileComponent } from './banner-mobile/banner-mobile.component';
import { PageSkeletonComponent } from '../page-skeleton/page-skeleton.component';
import { PurchaseProfileModalComponent } from '@app/views/private/shopkeeper/cast-off/purchase-profile/components/purchase-profile-modal/purchase-profile-modal.component';

const components = [
  HeaderSidebarComponent,
  SidebarComponent,
  FooterComponent,
  AdminLayoutComponent,
  AuthLayoutComponent,
  BlankLayoutComponent,
  AuthLayoutHeaderComponent,
  ShopkeeperLayoutComponent,
  ShopkeeperHeaderComponent,
  HeaderAccountDropdownComponent,
  OnlineEvaluationLayoutComponent,
  OnlineEvaluationHeaderComponent,
  PluginRaioXLayoutComponent,
  PluginRaioXTermsComponent,
  OnlineEvaluationTermsComponent,
  BannerMobileComponent,
  PageSkeletonComponent
];

@NgModule({
  imports: [
    NgbModule,
    RouterModule,
    FormsModule,
    SharedPipesModule,
    SharedDirectivesModule,
    PerfectScrollbarModule,
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    PurchaseProfileModalComponent,
  ],
  declarations: components,
  exports: [...components, PurchaseProfileModalComponent],
})
export class LayoutsModule { }
